import { QUERY_KEYS } from "constants/query";

import movieListApis from "apis/movies";
import { isNotEmpty } from "neetocist";
import { Toastr } from "neetoui";
import { equals } from "ramda";
import { useQuery } from "react-query";

export const useFetchMovies = params => {
  const { searchValue, page, type, year } = params;

  return useQuery({
    queryKey: [QUERY_KEYS.MOVIES, searchValue, page, type, year],
    queryFn: () => movieListApis.fetch({ searchValue, page, type, year }),
    enabled: !!params,
    keepPreviousData: true,
    onSuccess: ({ response, error }) => {
      if (equals(response, "False") && isNotEmpty(searchValue)) {
        Toastr.error(error, {
          autoClose: 2000,
        });
      }
    },
  });
};

export const useShowMovieDetails = id =>
  useQuery({
    queryKey: [QUERY_KEYS.MOVIE_DETAILS, id],
    queryFn: () => movieListApis.show(id),
    enabled: !!id,
    onSuccess: ({ response, error }) => {
      if (equals(response, "False") && error) {
        Toastr.error(error, {
          autoClose: 2000,
        });
      }
    },
  });
